import type {Thread} from '@github-ui/diff-lines/conversation-types'

import {getFirstComment} from '../../page-data/payloads/thread-previews'
import {ChevronRightIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {PreviewAuthors} from './PreviewAuthors'
import {useCommentNavigation} from '../../hooks/use-comment-navigation'
import {isThreadOutdated} from '../../helpers/thread-navigation'

type Props = {
  thread: Thread
  onNavigateToDiffComment?: () => void
  displayedCommentId?: number | null
  replyCount: number
}

export const NavigateToCommentButton = ({thread, onNavigateToDiffComment, displayedCommentId, replyCount}: Props) => {
  const firstComment = getFirstComment(thread)
  const commentId = displayedCommentId ?? firstComment?.databaseId
  const {href, onClick} = useCommentNavigation({
    commentId,
    isOutdated: isThreadOutdated(thread),
    sourceUri: thread.originalDiffPathUri,
    onNavigated: onNavigateToDiffComment,
  })

  const repliesText = replyCount === 0 ? 'No replies' : `${replyCount} ${replyCount === 1 ? 'reply' : 'replies'}`

  return (
    <Button as="a" href={href} size="small" trailingVisual={ChevronRightIcon} variant="invisible" onClick={onClick}>
      <div className="d-flex flex-row flex-justify-start flex-items-center gap-2">
        <span>{repliesText}</span>
        <PreviewAuthors thread={thread} skipBeforeCommentId={commentId} />
      </div>
    </Button>
  )
}
